<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <!-- Section des informations générales -->
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations générales</h4>
            
            <router-link
              to="/demandes-prix/liste-demande-prix"
              class="btn btn-primary transition border-0 lh-1 fw-medium"
            >
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Retour
            </router-link>
          </div>
          <table class="table">
            <tbody>
              <tr>
                <td>Date de demande</td>
                <td>{{ demandePrix?.dateDdp }}</td>
              </tr>
             
              <tr>
                <td>Fournisseur</td>
                <td>{{ demandePrix?.fournisseur?.nomFournisseur }}</td>
              </tr>
             
             
              <!-- <tr v-if="client?.telephone1">
                <td>Téléphone 1</td>
                <td>{{ client?.telephone1 }}</td>
              </tr>
              <tr v-if="client?.telephone2">
                <td>Téléphone 2</td>
                <td>{{ client?.telephone2 }}</td>
              </tr> -->
              <!-- <tr>
                <td>Date de naissance</td>
                <td>{{ client?.dateNais }}</td>
              </tr>
              <tr>
                <td>Raison sociale</td>
                <td>{{ client?.raisonSociale }}</td>
              </tr>
              <tr>
                <td>Ifu</td>
                <td>{{ client?.ifu }}</td>
              </tr>
              <tr>
                <td>Dénomination</td>
                <td>{{ client?.denomination }}</td>
              </tr>
              <tr>
                <td>Date création</td>
                <td>{{ client?.dateCreation }}</td>
              </tr> -->
            </tbody>
          </table>

          <div class="card-head box-shadow bg-white p-15 p-sm-20 p-md-25 mt-25">
            <!-- <h4 class="position-relative text-black fw-bold mb-10">Historique des affectations</h4> -->
            <table class="table">
              <thead>
                <tr>
                  <th>Référence Produit</th>
                  <th>Nom produit</th>
                  <th>Quantite</th>
                </tr>
              </thead>
             <tbody>
              <tr v-for="(demandePrix ,index) in demandePrix?.demandepriprocondis" :key="index">
                <td>{{ demandePrix?.refProd || 'N/A' }}</td>
                <td>{{demandePrix?.nomProd || 'N/A' }}</td>
                <td>{{ demandePrix.qtite || 'N/A' }}</td>
              </tr>
             
            </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/services/ApiService";
import { Client } from "@/models/Client";
import { error, format_Date } from "@/utils/utils";
import { useRoute } from "vue-router";
import { DemandePrix } from "@/models/DemandePrix";

export default defineComponent({
  name: "ViewDemandePrix",
  setup: () => {
    const route = useRoute();
    const demandePrix = ref<DemandePrix | null>(null);

    function getDemandePrix(id: string) {
      return ApiService.get(`/demandePrixs/${id}`)
        .then(({ data }) => {
          console.log("donnee:", data);
          demandePrix.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    // function getAffectationsByClient(clientId: string) {
    //   return ApiService.get(`/clients/${clientId}/affectations`)
    //     .then(({ data }) => {
    //       console.log("Données affectations reçues:", JSON.stringify(data, null, 2));
    //       console.log("Données affectations reçues:", data);
    //       affectations.value = data.data;
    //       console.log("Affectations dans ref:", affectations.value);
    //     })
    //     .catch(({ response }) => {
    //       error(response.data.message);
    //     });
    // }

    onMounted(() => {
      const id = route.params.id as string;
      getDemandePrix(id);
      // getAffectationsByClient(id); 
    });

    return {
     demandePrix,
      getDemandePrix,
      format_Date,
    };
  },
});
</script>